import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
//import { PayloadsDataGridComponent } from "./payloadsData/payloadsData-grid.component";
import { AgGridModule } from 'ag-grid-angular';
//import 'ag-grid-enterprise';
import { SpinnerComponent } from "../spinner/spinner.component";


@NgModule({
    declarations: [

    ],
    imports: [
        CommonModule,
        AgGridModule
    ],
    exports: [

    ]
})
export class GridsModule { }
